module.exports = __webpack_public_path__ + "static/img/DSC01782.420e234d.jpg";